export const NEWS_BASE_PATH = '/o-projekcie/aktualnosci'

export function newsArticlePath(slug: string): string {
  return `${NEWS_BASE_PATH}/${slug}`
}
